
function toggleAccordion(sectionId) {
    const section = document.getElementById(sectionId);
    const isVisible = section.classList.contains('max-h-[10000px]');
    section.classList.toggle('max-h-[10000px]');
    section.classList.toggle('sm:max-h-[10000px]');
    section.previousElementSibling.querySelector('span:last-child').textContent = !isVisible ? '-' : '+';
}

function openAccordion(sectionId) {
    const section = document.getElementById(sectionId);
    const isVisible = section.classList.contains('max-h-[10000px]');
    
    if(!isVisible) {
        section.classList.toggle('max-h-[10000px]');
        section.classList.toggle('sm:max-h-[10000px]');
        section.previousElementSibling.querySelector('span:last-child').textContent = !isVisible ? '-' : '+';
    }
}